module.exports = __webpack_public_path__ + "assets/img/user.c3bb9154.png";